export default "__VITE_ASSET__8ihE4ewm__"